/**
 *
 * @param {ModuleBuilderContext} baseContext
 * @param {string} name
 * @param {object} overrides
 *
 * @return {ModuleBuilderContext}
 */
export default function subContext (baseContext, name, overrides = {}) {
  const newContext = Object.assign({}, baseContext)
  newContext.$parentNamespace = newContext.$namespace
  newContext.$namespace += '/' + name
  newContext.$name = name

  return Object.assign(newContext, overrides)
}
